import React, { Component } from 'react'

import Breadcrumbs from '../block/Breadcrumbs'
import Docks from '../block/Docks'
import About from '../block/About'
import Stati from '../block/Stati'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <Breadcrumbs breadcrumbs={data?.breadcrumbs || []} />
        <Docks data={data} />
        <About data={data} />
        <Stati data={data} />
      </>
    )
  }
}

export default App